/*
  LLC "Shop" mega menu (snippets/llc-shop-menu.liquid).
  - Shop button opens and closes the panel; Escape, the scrim or a click outside close it.
  - Department rail is an ARIA tablist: hover, click, focus or arrow keys switch the pane.
  - The search bar opens Horizon's predictive search dialog (#search-modal).
*/
if (!customElements.get('llc-shop-menu')) {
  class LlcShopMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-llc-shop-toggle]');
      this.panel = this.querySelector('[data-llc-shop-panel]');
      this.scrim = this.querySelector('[data-llc-shop-scrim]');
      this.tabs = Array.from(this.querySelectorAll('[data-llc-shop-tab]'));
      this.search = this.querySelector('[data-llc-shop-search]');
      if (!this.toggle || !this.panel) return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.toggle.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
      this.scrim?.addEventListener('click', () => this.close());

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('focus', () => this.select(index));
        tab.addEventListener('mouseenter', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
      });

      this.search?.addEventListener('click', () => {
        this.close();
        const dialog = document.getElementById('search-modal');
        if (dialog && typeof dialog.showDialog === 'function') {
          dialog.showDialog();
        } else {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'search';
        }
      });
    }

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    open() {
      this.toggle.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      if (this.scrim) this.scrim.hidden = false;
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    close({ returnFocus = false } = {}) {
      if (!this.isOpen) return;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      if (this.scrim) this.scrim.hidden = true;
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (returnFocus) this.toggle.focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const pane = document.getElementById(tab.getAttribute('aria-controls'));
        if (pane) pane.hidden = !selected;
      });
    }

    onTabKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.tabs[next].focus();
    }

    onDocumentClick(event) {
      if (!this.contains(event.target) || event.target === this.scrim) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close({ returnFocus: true });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }
  }

  customElements.define('llc-shop-menu', LlcShopMenu);
}

// Quick-link dropdowns (e.g. Deals > Sale, Clearance, Bulk buy): click/Enter toggles, Escape or outside click closes.
// Hover and keyboard focus also open them via CSS (:hover, :focus-within).
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.llc-shop__quick-toggle');
  document.querySelectorAll('[data-llc-quick-dropdown] .llc-shop__quick-toggle[aria-expanded="true"]').forEach((btn) => {
    if (btn !== toggle) btn.setAttribute('aria-expanded', 'false');
  });
  if (toggle) toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = document.querySelector('[data-llc-quick-dropdown] .llc-shop__quick-toggle[aria-expanded="true"]');
  if (open) { open.setAttribute('aria-expanded', 'false'); open.focus(); }
});
